import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useLocalizeMessage } from 'libs.nucleus';
import { useDateTime, ListInformation, useCountriesOptions } from 'libs.react';
import { useRoleTranslations } from '../../features';
export const UserDetailsSection = ({ entityId, user }) => {
    const translate = useLocalizeMessage();
    const roleTranslations = useRoleTranslations();
    const { parseDateTimeShort } = useDateTime();
    const allCountries = useCountriesOptions();
    const listItems = useMemo(() => {
        const entityAccess = user.entitiesAccess.find((group) => group.entityId === entityId);
        const roles = entityAccess?.roleGroups.map((role) => roleTranslations[role]);
        const country = allCountries.find((c) => c.value === user.countryCode)?.label || user.countryCode;
        return [
            { title: translate('First name'), dataTestId: 'profile-first-name', description: user.first },
            { title: translate('Last name'), dataTestId: 'profile-last-name', description: user.last },
            { title: translate('Roles'), dataTestId: 'profile-roles', description: roles },
            { title: translate('Email'), dataTestId: 'profile-email', description: user.email },
            { title: translate('Country of residence'), dataTestId: 'profile-country', description: country },
            { title: translate('Created'), dataTestId: 'profile-email', description: parseDateTimeShort(user.createdAt) },
        ];
    }, [user]);
    return _jsx(ListInformation, { items: listItems });
};
